import React, { useState } from "react";

const TruncateWithExpand = ({ text, limit = 30 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > limit;
  const displayText = expanded ? text : text.slice(0, limit) + (isLong ? "..." : "");
    console.log(displayText);
  return (
    <div className=" ">
      
        {displayText}
      
      {isLong && (
        <button
          className="text-blue-500 text-xs ml-1"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show less" : "Load more"}
        </button>
      )}
    </div>
  );
};

export default TruncateWithExpand;
